import { CalendarDays, GanttChart, Kanban, LayoutList } from 'lucide-react'
import type { ViewType } from '@/store/ProjectViewPreferencesStore'

export const VIEW_TYPE_OPTIONS: Array<{
  value: ViewType
  labelKey: string
  icon: typeof LayoutList
}> = [
  { value: 'list', labelKey: 'views.list', icon: LayoutList },
  { value: 'board', labelKey: 'views.board', icon: Kanban },
  { value: 'calendar', labelKey: 'views.calendar', icon: CalendarDays },
  { value: 'gantt', labelKey: 'views.gantt', icon: GanttChart },
]
